var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({class:( _obj = {
    'button button--icon': true,
    'button--sm': _vm.size == 'sm',
    'active': _vm.active
  }, _obj[_vm.className] = true, _obj ),attrs:{"type":"button","disabled":_vm.disabled}},_vm.$listeners),[_c('icon',{attrs:{"icon":_vm.icon,"custom":_vm.custom}}),(_vm.$slots.default)?_c('span',[_vm._t("default")],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }